import React from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined, LogoutOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/images.jpeg';
import { StorageService } from '../../service/storage-service';

interface TopbarProps {
  showMenuButton?: boolean;
  onMenuClick?: () => void;
  isSidebarOpen?: boolean;
}

const Topbar = ({ showMenuButton, onMenuClick, isSidebarOpen }: TopbarProps) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    StorageService.clearStorage();
    navigate('/login');
  };

  return (
    <div className="bg-white h-16 flex items-center justify-between px-4 md:px-8 shadow-lg transition-all duration-300 border-b border-gray-100">
      <div className="flex items-center space-x-4">
        {showMenuButton && (
          <button
            onClick={onMenuClick}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-opacity-50"
            aria-label={isSidebarOpen ? "Close menu" : "Open menu"}
          >
            {isSidebarOpen ? <MenuFoldOutlined className="text-gray-600" /> : <MenuUnfoldOutlined className="text-gray-600" />}
          </button>
        )}
        <div className="flex items-center space-x-2 group cursor-pointer">
          <div className="overflow-hidden rounded-lg">
            <img 
              src={logo} 
              alt="Pinnacle Echo Logo" 
              className="h-12 w-auto object-cover transform transition-transform duration-300 group-hover:scale-105" 
            />
          </div>
          <h1 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-cyan-800 to-cyan-600 bg-clip-text text-transparent">
            Pinnacle Echo
          </h1>
        </div>
      </div>
      <Tooltip title="Logout" placement="bottom">
        <Button
          type="text"
          icon={<LogoutOutlined />}
          onClick={handleLogout}
          className="text-gray-600 hover:text-cyan-600 hover:bg-gray-50 transition-colors duration-200 px-4 h-10"
        >
          <span className="hidden md:inline ml-1">Logout</span>
        </Button>
      </Tooltip>
    </div>
  );
};

export default Topbar; 